import { Box } from '@mui/material';
import React from 'react';

import { LevelOneMenuItem } from '../../LevelOne/LevelOneMenuItem';

import { useSwitchMenuContext } from './SwitchMenuContext';
import { SwitchSubmenu } from './SwitchSubmenu';
interface ISwitchMenuTabProps {
  label: string;
  isSelected: boolean;
  firstSwitchInputRef: React.MutableRefObject<HTMLInputElement>;
  handleClick(): void;
}

const SwitchMenuTabBase: React.ForwardRefRenderFunction<HTMLLIElement, ISwitchMenuTabProps> = (
  { label, isSelected, firstSwitchInputRef, handleClick },
  ref
) => {
  return (
    <LevelOneMenuItem
      ref={ref}
      styleOverrides={{ maxWidth: '300px' }}
      item={{
        id: 'switch-menu-tab-button',
        label: label,
        tooltipText: undefined
      }}
      isSelected={isSelected}
      handleClick={handleClick}
      firstLevelTwoItemRef={firstSwitchInputRef}
    />
  );
};
export const SwitchMenuTab = React.forwardRef(SwitchMenuTabBase);

export const DesktopSwitchMenu = () => {
  const { menuItems, menuButtonLabel } = useSwitchMenuContext();
  const switchMenuRef = React.useRef(null);
  const [open, setOpen] = React.useState(false);
  const firstSwitchInputRef = React.useRef<HTMLInputElement>(null);

  return (
    <Box sx={{ height: '100%' }} role="menu">
      <SwitchMenuTab
        ref={switchMenuRef}
        label={menuButtonLabel}
        handleClick={() => setOpen(!open)}
        isSelected={open}
        firstSwitchInputRef={firstSwitchInputRef}
      />
      <SwitchSubmenu
        anchorEl={switchMenuRef.current}
        open={open}
        handleClose={() => setOpen(false)}
        switchMenuItems={menuItems}
        firstSwitchInputRef={firstSwitchInputRef}
      />
    </Box>
  );
};
